import { css } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';
import { tablet } from '../utils';

export const styles = css`
  :host {
    display: inline-block;
    margin-right: ${pxToRem(5)};
  }

  ::slotted(*),
  :host {
    font-size: ${pxToRem(12)};
  }

  ::slotted(*:hover) {
    text-decoration: underline;
  }

  .menu-item {
    --button-color: #939393;
    line-height: 2;
  }

  ::slotted(*) {
    line-height: 2;
  }

  ${tablet(css`
    .menu-item {
      --button-color: #66c05d;
      line-height: 1.398;
    }

    ::slotted(*) {
      line-height: 1.398;
    }
  `)}
`;
